import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import English from "./langs/en-US";
import French from "./langs/fr-CA";
import customLanguageDetector from "./language-detector";

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customLanguageDetector);

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(languageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en-US",
    detection: {
      order: ["customDetector"],
    },
    resources: {
      "en-US": {
        translation: English,
      },
      "fr-CA": {
        translation: French,
      },
    },
  });

export default i18n;
